import React from 'react';
import { Calendar, Modal, Badge, Flex, message, Button } from 'antd';
import SwitchShop from '../shop/switch-shop';
import { getCurrentShopId } from '../shop/get-current-shop';
import dayjs from 'dayjs';
import Appointment from './appointment';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {TwoStepFlow, PayFlow} from '../../components/order-flow';

export default () => {
  const [shopId, setShopId] = React.useState(null);
  const today = dayjs();
  const [appointments, setAppointments] = React.useState([]);
  const [noAppointments, setNoAppointments] = React.useState([]);
  const [selectedAppointments, setSelectedAppointments] = React.useState([]);
  const [selectedDay, setSelectedDay] = React.useState();
  const [order, setOrder] = React.useState({});
  const [isOpen, setIsOpen] = React.useState(false);
  // 当月第一天
  let firstDay = dayjs().startOf('month'); // ✅ 获取当月第一天
  firstDay = dayjs(firstDay - 13 * 24 * 3600 * 1000).toDate();
  let endDay = dayjs().endOf('month');   // ✅ 获取当月最后一天
  endDay = dayjs(endDay + 13 * 24 * 3600 * 1000).toDate();
  
  React.useEffect(() => {
    const fetchShopId = async () => {
      const id = await getCurrentShopId();
      setShopId(id);
    };
    
    fetchShopId();
  }, []);
  
  React.useEffect(() => {
    if (shopId) {
      loadData();
    }
  }, [shopId]);

  const loadData = async () => {
    getAppointments(firstDay.toISOString(), endDay.toISOString()).then(res => {
      setAppointments(res);
      onSelect(today, res);     // ✅ 触发一次选择事件以筛选今日数据
    });

    getNoAppointments().then(res => {
      setNoAppointments(res);
    });
  }

  const getAppointments = async (startDate, endDate) => {
    if (!shopId) return [];
    
    const params = new URLSearchParams();
    params.append('shopId', shopId);

    if(startDate) {
      params.append('startDate', startDate);
    }
    if(endDate) {
      params.append('endDate', endDate);
    }

    let response = await fetch(`/api/order/appointment?${params.toString()}`);
    let result = await response.json();

    if(result.success){
      const rows = result?.data?.rows || [];
      // 按 appointmentTime排序
      rows.sort((a, b) => dayjs(a.appointmentTime).unix() - dayjs(b.appointmentTime).unix());
      return rows
    }

    return [];
  }

  const getNoAppointments = async (startDate, endDate) => {
    if (!shopId) return [];
    
    const params = new URLSearchParams();
    params.append('shopId', shopId);

    let response = await fetch(`/api/order/no-appointment?${params.toString()}`);
    let result = await response.json();

    if(result.success){
      const rows = result?.data?.rows || [];
      // 按 appointmentTime排序
      rows.sort((a, b) => dayjs(a.createTime).unix() - dayjs(b.createTime).unix());
      return rows
    }

    return [];
  }

  const dateCellRender = value => {
    return (
      <div>
        <div style={{textAlign: 'center', fontWeight: 'bold'}}>
          {dayjs().format('YYYYMMDD') === dayjs(value).format('YYYYMMDD') && <span style={{fontSize: '10px', color: 'green'}}>今天</span>}
          {(value).format('DD')}
        </div>
        {appointments
          .sort((a, b) => dayjs(a.appointmentTime).unix() - dayjs(b.appointmentTime).unix())
          .map(item => {
            const dayStart = dayjs(value).startOf('day');
            const dayEnd = dayjs(value).endOf('day');
            const createTime = dayjs(item.appointmentTime);

            if(createTime >= dayStart && createTime <= dayEnd){
              return (
                <div key={item.id} style={{fontSize: 10, textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                  { item.status === 0 
                    ? <Badge count={item?.times} size="small" color='red' /> 
                    : ( item.status === 8 ? <Badge count={item?.times} size="small" color='gray' /> : <Badge count={item?.times} size="small" color='green' /> )
                  }
                  {/* <span style={{fontSize: '10px'}}>[{item?.times}]</span> */}
                  {(item.community || '') + item.address}
                </div>
              )
            }

          return null;
        })}
      </div>
    );
  };

  const cellRender = (current, info) => {

    // console.log('=======', info);
    if (info.type === 'date') {
      if(dayjs(current).format('YYYYMMDD') == dayjs(selectedDay).format('YYYYMMDD')) {
        return (
          <a href="#currentDay" style={{color: 'green', textDecoration: 'underline'}}>
            {dateCellRender(current)}
          </a>
        );
      }
      return dateCellRender(current);
    }
    return info.originNode;
  };

  const onSelect = (value, apps) => {
    setSelectedDay(value);
    // setValue(value);
    let selected = apps || appointments;
    selected = selected.filter((item) => {
      const dayStart = dayjs(value).startOf('day');
      const dayEnd = dayjs(value).endOf('day');
      const appointmentTime = dayjs(item.appointmentTime);

      return (appointmentTime >= dayStart && appointmentTime <= dayEnd);
    });

    setSelectedAppointments(selected);
  };

  const onChange = (value) => {

    const f = dayjs(dayjs(value).startOf('month') - 13 * 24 * 3600 * 1000).toDate();
    const e = dayjs(dayjs(value).endOf('month') + 13 * 24 * 3600 * 1000).toDate();

    getAppointments(f.toISOString(), e.toISOString()).then(res => {
      setAppointments(res);
    });
  };

  return (
    <div className="space-y-4">
      <SwitchShop />
      <div className="admin-card p-4">
        <Calendar onChange={onChange} fullscreen={false} fullCellRender={cellRender} onSelect={value => onSelect(value)} />
      </div>
      <div>
        <Flex gap={2} align='center' className="mb-3">
          <h3 className="admin-section-title m-0">{dayjs(selectedDay).format('YYYY-MM-DD')} 日程</h3>
          <a href={`/schedule/map?day=${dayjs(selectedDay)}`} className="text-primary text-sm hover:underline">查看地图</a>
        </Flex>
        <Appointment id="currentDay" appointments={selectedAppointments} onChange={loadData} pagination={false} />
      </div>
      <div>
        <h3 className="admin-section-title">待预约</h3>
        <Appointment appointments={noAppointments} onChange={loadData} pagination={false} />
      </div>
    </div>
  );
};